/*** IMPORTS FROM imports-loader ***/
(function() {

define([
  'jquery',
  'mustache',
  'pip-model',
  'velocity',
  'plugin.tooltip',
  'pip-common.utils'
],
  function assemblyAddOn(
    $,
    Mustache,
    pip,
    velocity,
    tooltip,
    utils
  ) {
    var view = {
      selectors: {
        assemblySection: '#add-on__container',
        optInCheckbox: '#assembly__checkbox',
        whatToExpect: '.buybox__assembly .buybox__add-on__learn-more-cta',
      },
      templates: {
        assemblyAddOn: $('#assembly-add-on').html(),
        assemblyMultiAddOn: $('#assembly-multi-add-on').html(),
        assemblyTooltip: $('#assembly-tooltip').html()
      },
      determineTemplates: function determineTemplates(addOns) {
        this.template = view.templates.assemblyAddOn;
        this.container = view.selectors.assemblySection;

        if (addOns && addOns.multipleAddOns && addOns.side) {
          this.template = view.templates.assemblyMultiAddOn;
          this.container = '#multi-add-on-' + addOns.side;
        }
      }
    }

    function isAtHomeAssemblyAddOnDisplayable() {
      return pip.serviceAddOns
        && pip.serviceAddOns.proReferral
        && pip.serviceAddOns.proReferral.isAtHomeAssembly;
    }

    function initEventListeners() {
      // TODO: Is tooltip a jquery plugin?
      var tooltipOptions = {
        type: 'click',
        position: 'bottom',
        content: view.templates.assemblyTooltip,
        width: utils.getTooltipSize(),
        closeButton: true,
        bestPosition: false,
        closeOnClick: true
      };
      $(view.selectors.whatToExpect).tooltip(tooltipOptions);

      $(document).off('.assembly');
      $(document).on('change.assembly', view.selectors.optInCheckbox, function () {
        if ($(this).is(':checked')) {
          $(view.selectors.whatToExpect).tooltip('open');
        }
        else {
          $(view.selectors.whatToExpect).tooltip('close');
        }
        pip.customer.isOptedIntoAssembly = $(this).is(':checked');
      });
    }

    return {
      init: function init(addOns) {
        if (!isAtHomeAssemblyAddOnDisplayable()) return;

        view.determineTemplates(addOns);
        $(view.container).html(Mustache.render(view.template, pip.serviceAddOns.proReferral)).velocity('slideDown', { duration: 300 });
        initEventListeners();
      },

      isAtHomeAssemblyAddOnDisplayable: isAtHomeAssemblyAddOnDisplayable
    }
  });

}.call(window));